import { dateSameDay } from 'common/display-state/display-time.js';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DATE_FORMATS, formatDate } from 'utilities/date.js';

export const getDayForecastSlug = (date: Date) => {
  return `forecast-${formatDate(date, DATE_FORMATS.DateParse)}`;
};

export const DayQueryParam = ({ days, hasSlug }: { days: { date: string }[]; hasSlug?: boolean }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryParamLocation = searchParams.get('day');
  const [indx, setIndx] = useState<number>();
  const navigate = useNavigate();

  useEffect(() => {
    if (queryParamLocation) {
      // query param data ?day=2025-04-10 YYYY-MM-DD
      const paramArgs = queryParamLocation.split('-').map((dateStr) => parseInt(dateStr, 10));
      const queryParamDateObj = new Date(paramArgs[0], paramArgs[1] - 1, paramArgs[2]); // paramArgs[1] - 1 as month is 0 indexed
      const matchingIndex = days.findIndex((day) => {
        // day.date "2025-05-05T12:00:00+12:00",
        const daysDate = new Date(day.date);
        return dateSameDay(queryParamDateObj, daysDate);
      });
      searchParams.delete('day');
      setSearchParams(searchParams);

      if (matchingIndex >= 0) {
        setIndx(matchingIndex);
        if (hasSlug) {
          navigate(`#${getDayForecastSlug(queryParamDateObj)}`);
        }
      }
    }
  }, [queryParamLocation, days, searchParams, setSearchParams, hasSlug, navigate]);

  return indx;
};
